import PropTypes from "prop-types";
import { FormGroup, Label, Input } from "reactstrap";
import { Controller } from "react-hook-form";

const InputController = ({
    id,
    name,
    control,
    placeholder,
    label,
    type,
    rules,
    errors,
    onInput,
    ...props
}) => {
    return (
        <FormGroup>
            <Label for={name}>{label}</Label>
            {control == null ? (
                <Input
                    {...props}
                    id={id ?? name}
                    onInput={onInput}
                    type={type ?? "text"}
                    placeholder={placeholder ?? label}
                />
            ) : (
                <>
                    <Controller
                        name={name}
                        control={control}
                        rules={rules}
                        render={({ field }) => {
                            return (
                                <Input
                                    {...field}
                                    {...props}
                                    id={id ?? name}
                                    onInput={onInput}
                                    type={type ?? "text"}
                                    invalid={
                                        errors != null && errors[name] != null
                                    }
                                    placeholder={placeholder ?? label}
                                />
                            );
                        }}
                    />
                    {errors != null && errors[name] && (
                        <span className="invalid-feedback">
                            {errors[name].message}
                        </span>
                    )}
                </>
            )}
        </FormGroup>
    );
};

InputController.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    control: PropTypes.object,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string,
    rules: PropTypes.object,
    errors: PropTypes.object,
    onInput: PropTypes.func,
};

export default InputController;
